import React from 'react';

import { default as Loading } from 'react-loader-spinner';

import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

export default () => <Loading type="ThreeDots" color="#FFF" width={50} height={30} />;
